import { render, staticRenderFns } from "./DropdownButtonContent.vue?vue&type=template&id=25a9c6a8"
import script from "./DropdownButtonContent.vue?vue&type=script&lang=js"
export * from "./DropdownButtonContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports